import { render, staticRenderFns } from "./FPTemp4.vue?vue&type=template&id=0ee133ae&scoped=true&"
import script from "./FPTemp4.vue?vue&type=script&lang=js&"
export * from "./FPTemp4.vue?vue&type=script&lang=js&"
import style0 from "./FPTemp4.vue?vue&type=style&index=0&id=0ee133ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee133ae",
  null
  
)

export default component.exports